import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from "./component/UserContext";
import { ASSET_BASE_URL } from "./config/env";

const FormHeader = ({}) => {
  const { user, logout } = useContext(UserContext);
  const navigate = useNavigate();

  const role = user.role;
  const operatorId = user.operatorId;
  const createdBy = user.createdBy;

  const handelDashboradShift = () => {
    if (role === "superadmin") {
      navigate("/superadmin");
    } else if (role === "admin") {
      navigate("/admin");
    } else if (role === "operator") {
      navigate("/operator")
    } else {
      logout();
    }
  }

  return ( 
    <header className={(operatorId === 228 || createdBy === 228) ? "header-stremfi": "header"}>
      <div className="header-content form-header-content">
        {(operatorId === 228 || createdBy === 228) ? (
          <img src={`${ASSET_BASE_URL}/stremfi.png`} alt="StremFi" className="logo" onClick={() => handelDashboradShift()} />
        ) : (
          <img src={`${ASSET_BASE_URL}/vrplay1.png`} alt="VRPlay" className="logo" onClick={() => navigate("/operator", { replace: true })} />
        )}
        <Link to={-1} className="back-link">
            ← Back
        </Link>
      </div>
    </header>
  );
};

export default FormHeader;
